/**
 * =============================================================================
 * nav.js
 * =============================================================================

 * =============================================================================
 */

 var Nav = {
  init: function() {
    this.setupScrollListener();
    document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
    document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));
    document.addEventListener('geo-notifications:updated', this.onGeoNotificationsUpdated.bind(this));
  },

  /**
   * Automatically called by mp.js when document is ready. Perform any jQuery
   * setup for the extension here (e.g. event listeners, initial state)
   */
  onReady: function(){
    this.recalculateNavOffset();
    this.getOffcanvasStatus();
    this.setupMegamenuKeyboard();
  },

  /**
   * Make the desktop hover megamenu keyboard-operable (WCAG 2.1.1, 4.1.2).
   *
   * The panel reveal is CSS-driven via `.dropdown:focus-within` (see
   * custom.scss), so tabbing to a top-level item opens its panel and tabbing
   * onward walks the panel links. Here we (a) keep each toggle's
   * `aria-expanded` in sync with focus, and (b) let Escape collapse the panel
   * while leaving focus on the toggle.
   *
   * Scoped to `.megamenu` dropdowns only — the account / locale dropdowns use
   * Bootstrap's own keyboard + aria handling and must not be touched here.
   */
  setupMegamenuKeyboard: function() {
    var dropdowns = document.querySelectorAll('.navbar-nav .nav-item.dropdown');
    dropdowns.forEach(function(dropdown) {
      var panel = dropdown.querySelector('.megamenu');
      var toggle = dropdown.querySelector('.nav-link');
      if (!panel || !toggle) return;

      dropdown.addEventListener('focusin', function() {
        // A focus() we triggered ourselves on Escape sets this flag so the
        // panel doesn't immediately re-open.
        if (dropdown.dataset.mpEscaped === 'true') {
          delete dropdown.dataset.mpEscaped;
          return;
        }
        dropdown.classList.remove('mp-dropdown-collapsed');
        toggle.setAttribute('aria-expanded', 'true');
      });

      dropdown.addEventListener('focusout', function(e) {
        // Only collapse once focus has left the whole dropdown.
        if (!dropdown.contains(e.relatedTarget)) {
          dropdown.classList.remove('mp-dropdown-collapsed');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });

      dropdown.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          dropdown.classList.add('mp-dropdown-collapsed');
          toggle.setAttribute('aria-expanded', 'false');
          dropdown.dataset.mpEscaped = 'true';
          toggle.focus();
        }
      });
    });
  },

  recalculateNavOffset: function() {
    let notificationBarSection = document.getElementById("shopify-section-static-notification-bar");
    let navOffcanvasOffset = 0;
    if(notificationBarSection) {
      navOffcanvasOffset = Math.max(0, notificationBarSection.offsetHeight - window.scrollY);
    }
    navOffcanvasOffset += document.getElementById("shopify-section-static-header").offsetHeight;
    document.querySelector('body').style.setProperty("--nav-offcanvas-offset", navOffcanvasOffset + "px");
    return navOffcanvasOffset;
  },

  /**
   * Notification bars now support geolocation, so we need to adjust height once
   * they're done loading or hiding
   */
  onGeoNotificationsUpdated: function(){
    let newOffset = this.recalculateNavOffset();
    // console.log('[G-N] newOffset', newOffset);
  },

  onScrollDown: function(e) {
    //console.log('[N] scrollDown diff', e.detail.difference);
    this.recalculateNavOffset();
    // Also check if we've actually scrolled past the header area
    let notificationBarSection = document.getElementById("shopify-section-static-notification-bar");
    let navOffcanvasOffset = 0;
    if(notificationBarSection) {
      navOffcanvasOffset = Math.max(0, notificationBarSection.offsetHeight - window.scrollY);
    }
    if(e.detail.difference > 5 && navOffcanvasOffset === 0) {
      document.getElementById('shopify-section-static-header').classList.remove('scrolled-up');
      document.getElementById('shopify-section-static-header').classList.add('scrolled-down');
    }
  },

  onScrollUp: function(e) {
    //console.log('[N] scrollUp diff', e.detail.difference);
    this.recalculateNavOffset();
    if(e.detail.difference > 5) {
      document.getElementById('shopify-section-static-header').classList.remove('scrolled-down');
      document.getElementById('shopify-section-static-header').classList.add('scrolled-up');
    }
  },

  /*
    Bug fix on android chrome: header was dissapearing on scroll within nav-offcanvas
  */
  getOffcanvasStatus: function() {
    var offcanvasMenu = document.getElementById('nav-offcanvas');
    offcanvasMenu.addEventListener('shown.bs.offcanvas', function () {
      document.getElementById('shopify-section-static-header').classList.add('navbar-shown');
      // console.log('offcanvas navbar shown');
    });
    offcanvasMenu.addEventListener('hidden.bs.offcanvas', function () {
      document.getElementById('shopify-section-static-header').classList.remove('navbar-shown');
      // console.log('offcanvas navbar hidden');
    })
  },
  setupScrollListener: function() {
    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    window.addEventListener("scroll", function(e){
      var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      var difference = Math.abs(st - lastScrollTop);
      // Add a 'tolerance' to prevent microscrolls from retriggering (e.g. on touch devices, there's usually a very small scroll up after scrolling down)
      if (st > lastScrollTop){
        var event = new CustomEvent("interaction:down-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      } else {
        var event = new CustomEvent("interaction:up-scroll", {
          detail: {
            difference: difference
          }
        });
        document.dispatchEvent(event);
      }
      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);
  }
}

export default Nav;